module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/SnowDepth/Kanagawa_SnowDepth_MRI_RCP85_End.png";